<div>
    <div class="static_steps">
        <div [formGroup]="form"  class="step">
            <div class="step_title">
              <span>
                {{"Catalogs.catalog_products_summary"| translate}}
              </span>
            </div>
            <div class="content top_content">
                <div class="total_title">
                    <span class="total">{{getLengthProductsPlusVariants()}}</span>
                    <span>{{"Catalogs.products_included" | translate}}</span>
                </div>
                <div class="tabs_group">
                  <mat-tab-group>
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <div class="title_block">
                          <img src="assets/icones/overall-price.svg" alt="">
                          {{"Catalogs.overall_discount_adj" | translate}}.
                        </div>
                      </ng-template>
                      <div class="inline_block">
                        <div class="field category_field">
                          <input type="number" formControlName="general_discount" (input)="onGeneralDiscountChange($event)" (wheel)="disableScrollChange($event)">
                          <span class="indicate_input custom_indic">%</span>
                          <span class="error_ms" *ngIf="form.get('general_discount')?.touched  && form.get('general_discount')?.errors">
                            {{"common.required_field" | translate}}
                          </span>
                        </div>
                      </div>
                    </mat-tab>
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <div class="title_block">
                          <img src="assets/icones/overall-quantity.svg" alt="">
                          {{"Catalogs.overall_quantity_adjustement" | translate}}.
                        </div>
                      </ng-template>
                      <div class="inline_block">
                        <div class="field">
                          <input type="number" formControlName="increment" (input)="onGeneralIncrementChange($event)" (input)="sanitize($event)" (wheel)="disableScrollChange($event)">
                          <span class="indicate_input custom_indic">{{"Catalogs.increment"| translate}}</span>
                          <span class="error_ms" *ngIf="form.get('increment')?.touched && form.get('increment')?.hasError('required')">
                            {{"common.required_field" | translate}}
                          </span>
                          <span class="error_ms"  *ngIf="form.hasError('increment')">{{ form.getError('increment') }}</span>
                          <span class="error_ms"  *ngIf="form.hasError('incrementMin')">{{ form.getError('incrementMin') }}</span>
                        </div>
                        <div class="field">
                          <input type="number" formControlName="min_qte" (change)="onGeneralMinChange($event)" (input)="sanitize($event)" (wheel)="disableScrollChange($event)">
                          <span class="indicate_input custom_indic">{{"Catalogs.min" | translate}}</span>
                          <span class="error_ms" *ngIf="form.get('min_qte')?.touched  && form.get('min_qte')?.hasError('required')">
                            {{"common.required_field" | translate}}
                          </span>
                          <span class="error_ms"  *ngIf="form.hasError('minQte')">{{ form.getError('minQte') }}</span>
                        </div>
                        <div class="field">
                          <input type="number" formControlName="max_qte" (change)="onGeneralMaxChange($event)" (input)="sanitize($event)" (wheel)="disableScrollChange($event)">
                          <span class="indicate_input custom_indic">{{"Catalogs.max" | translate}}</span>
                          <span class="error_ms" *ngIf="form.get('max_qte')?.touched  && form.get('max_qte')?.hasError('required')">
                            {{"common.required_field" | translate}}
                          </span>
                          <span class="error_ms" *ngIf="form.hasError('minMax')">{{ form.getError('minMax') }}</span>
                        </div>
                        <div>
                          <ng-container *ngIf="!edit">
                            <button class="cached" *appHasPermission="submitPermission()">
                              <mat-icon (click)="restoreQuantity()" >cached</mat-icon>
                            </button>
                          </ng-container>
                        </div>
                      </div>
                      <div class="inline_block">
                        <div class="field">
                          <label for="">{{ "Catalogs.can_be_sold_out_of_stock" | translate }}</label>
                          <mat-slide-toggle formControlName="can_be_sold_out_of_stock" (change)="onCanBeSoldOutOfStockChange($event)">
                          </mat-slide-toggle>
                        </div>
                        <div class="field">
                          <label for="">{{ "Catalogs.show_stock" | translate }}</label>
                          <mat-slide-toggle formControlName="show_stock">
                          </mat-slide-toggle>
                        </div>
                      </div>
                    </mat-tab>
                    <mat-tab disabled>
                      <ng-template mat-tab-label>
                        <div class="title_block">
                          <img src="assets/icones/volume.svg" alt="">
                          {{"Catalogs.overall_volume_adj"|translate}}
                        </div>
                      </ng-template>
                    </mat-tab>
                  </mat-tab-group>
                </div>
            </div>
        </div>
        <div [formGroup]="productsForm" class="step step_table">
          <div class="step_title inline_title">
            <div>
              <span>{{"Catalogs.products_included"| translate}}({{selectedProducts.length}})</span>
            </div>
          </div>
          <div class="inside_content">
            <table class="listing_table">
              <thead class="header_stiky">
                <tr class="head_table">
                  <th>{{"common.image" | translate}}</th>
                  <th>{{"common.name" | translate}} <br> {{"inventory.sku" | translate}}</th>
                  <th>{{"Catalogs.variant"| translate}}</th>
                  <th>{{"Catalogs.product_cost"| translate}}</th>
                  <th>{{"Catalogs.retail_price" | translate}}</th>
                  <th>{{"Catalogs.discount" | translate}}</th>
                  <th>{{"Catalogs.mark_up" | translate}}</th>
                  <th>{{"Catalogs.final_price"| translate}}</th>
                  <th>{{"Catalogs.quantity_preference" | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let product of selectedProducts; let i = index;" >
                  <tr class="body_table" [style]="{ padding: '10px 0px'}">
                    <td class="first_td">
                      <img *ngIf="product.image" class="listing_image" [src]="baseUrl + product.image + '?thumbnail=1'" alt="">
                      <img *ngIf="!product.image" class="listing_image no-image" src="assets/icones/default-image-product.svg" alt="">
                    </td>
                    <td class="td_block description_cell">
                      <span class="bold_span descr_elemnt">{{ product.name }}</span><br>
                      <span class="light_span descr_elemnt">{{product.sku}}</span>
                    </td>
                    <td class="td_actions">
                      <span class="bold_span">
                        {{product.variants ? product.variants.length : 0}}
                      </span>
                      <img *ngIf="product.attributes && product.attributes.length > 0" (click)="toggleVariants(product.id!)" [class]="expandedIndex === product.id  || (product.id && invalidProductIds && invalidProductIds.includes(product.id)) ? 'arrow_down arrow_up' : 'arrow_down'" src="assets/icones/arrow_down.svg" alt="">
                      <span *ngIf="product.attributes && product.attributes.length > 0" (click)="toggleVariants(product.id!)" class="open_variants">{{expandedIndex === product.id  || (product.id && invalidProductIds && invalidProductIds.includes(product.id)) ? ('inventory.HIDE' | translate) : ('inventory.SHOW' | translate) }}</span>
                    </td>
                    <td>
                      {{product.variants?.length === 0 && product.cost && product.cost >= 0 ? product.cost.toFixed(2) + '€' : '__'}}
                    </td>
                    <td>
                      {{product.variants?.length === 0 && product.sales_price && product.sales_price >= 0 ? product.sales_price.toFixed(2) + '€' : '__'}}
                    </td>
                    <td>
                      <div class="last_td" *ngIf="product.sales_price || product.variants?.length">
                        <input class="input_table" [value]="product.discount" [readonly]="!canSubmit" type="number" (input)="onDiscountChange($event, product)" (wheel)="disableScrollChange($event)">
                        <span class="indicate_input custom_indic">%</span>
                      </div>
                    </td>
                    <td>{{product.variants?.length === 0 && getFMarkUp(product) ? getFMarkUp(product) + '€' : '__'}}</td>
                    <td>
                      <div *ngIf="product.variants?.length === 0">
                        <div [style]="{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '5px'
                        }">
                          <div class="last_td">
                            <input class="input_table" [formControlName]="'final_price_'+product.id" type="number" [value]="product.final_price" (input)="onFinalPriceChange($event, i, product)" (wheel)="disableScrollChange($event)">
                            <span class="indicate_input custom_indic">€</span>
                          </div>
                          <img *ngIf="product.final_price == null" src="../../../../../assets/icones/alert-circle.svg" alt="">
                        </div>
                        <span class="error_ms" *ngIf="productsForm.get('final_price_' + product.id)?.touched  && productsForm.get('final_price_' + product.id)?.errors">
                          {{"common.required_field" | translate}}
                        </span>
                      </div>
                    </td>
                    <td class="last_td">
                      <div class="info_hint">
                        <img src="assets/icones/info.svg" alt="">
                        <span>{{"quotations_and_orders.overall_quantity"|translate}}</span>
                      </div>
                      <div class="cover_div">
                        <div class="info_hint">
                          <img src="assets/icones/info.svg" alt="">
                          <span>{{"quotations_and_orders.overall_quantity"|translate}}</span>
                        </div>
                        <div class="spans">
                          <span>{{"Catalogs.min"|translate}} : {{product.min_qte}}</span>
                          <span>{{"Catalogs.max"|translate}} : {{product.max_qte}}</span>
                          <span>{{"Catalogs.increment"|translate}}: {{product.increment}}</span>
                          <span>{{"Catalogs.can_be_sold_out_of_stock_short"|translate}}: {{(product.can_be_sold_out_of_stock ? 'common.yes' : 'common.no') | translate}}</span>
                        </div>
                        <div class="info_hint override" *appHasPermission="submitPermission()" (click)="openOverride(i, product, 'product')">
                          <img src="../../../../../assets/icones/add.svg" alt="">
                          <span>{{"Catalogs.overrides"|translate}}</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="expandedIndex === product.id || (product.id && invalidProductIds && invalidProductIds.includes(product.id))">
                    <td colspan="9" class="td_variants">
                      <div class="variants_scroll">
                        <table class="variant_table">
                          <tr *ngFor="let variant of product.variants" class="body_table">
                            <td class="first_td_variants">
                              <img *ngIf="variant.image" class="listing_image" [src]="baseUrl + variant.image + '?thumbnail=1'" alt="">
                              <img *ngIf="!variant.image" class="listing_image" src="assets/icones/no-image.png" alt="">
                            </td>
                            <td class="td_block description_cell">
                              <span class="bold_span descr_elemnt">
                                {{ variant.values.join(' / ') }}
                              </span>
                              <br>
                              <span class="descr_elemnt">
                                {{ variant.sku }}
                              </span>
                            </td>
                            <td></td>
                            <td>{{variant.cost && variant.cost >= 0 ? variant.cost!.toFixed(2) + '€' : '__'}}</td>
                            <td>{{variant.sales_price && variant.sales_price >= 0 ? variant.sales_price!.toFixed(2) + '€' : '__'}}</td>
                            <td>
                              <div class="last_td" *ngIf="variant.sales_price">
                                <input class="input_table" [value]="variant.discount" [readonly]="!canSubmit" type="number" (input)="onDiscounVariantChange($event, i, variant)" (wheel)="disableScrollChange($event)">
                                <span class="indicate_input custom_indic">%</span>
                              </div>
                            </td>
                            <td>{{ getFMarkUpVariant(variant) ? getFMarkUpVariant(variant) + '€' : '__' }}</td>
                            <td>
                              <div>
                                <div [style]="{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  gap: '5px'
                                }">
                                  <div class="last_td">
                                    <input class="input_table" [formControlName]="'variant_' + variant.id + '_final_price'" [value]="variant.final_price" type="number" (input)="onFinalPriceVariantChange($event, i, variant)" (wheel)="disableScrollChange($event)">
                                    <span class="indicate_input custom_indic">€</span>
                                  </div>
                                  <img *ngIf="variant.final_price == null" src="../../../../../assets/icones/alert-circle.svg" alt="">
                                </div>
                                <span class="error_ms" *ngIf="productsForm.get('variant_' + variant.id + '_final_price')?.touched  && productsForm.get('variant_' + variant.id + '_final_price')?.errors">
                                  {{"common.required_field" | translate}}
                                </span>
                              </div>
                            </td>
                            <td class="last_td">
                              <div class="info_hint">
                                <img src="assets/icones/info.svg" alt="">
                                <span>{{"quotations_and_orders.overall_quantity"|translate}}</span>
                              </div>
                              <div class="cover_div">
                                <div class="info_hint">
                                  <img src="assets/icones/info.svg" alt="">
                                  <span>{{"quotations_and_orders.overall_quantity"|translate}}</span>
                                </div>
                                <div class="spans">
                                  <span>{{"Catalogs.min"|translate}} : {{variant.min_qte}}</span>
                                  <span>{{"Catalogs.max"|translate}}: {{variant.max_qte}}</span>
                                  <span>{{"Catalogs.increment"|translate}} : {{variant.increment}}</span>
                                  <span>{{"Catalogs.can_be_sold_out_of_stock_short" | translate}}: {{(product.can_be_sold_out_of_stock ? 'common.yes' : 'common.no') | translate}}</span>
                                </div>
                                <div class="info_hint override" *appHasPermission="submitPermission()" (click)="openOverride(i, variant, 'variant')">
                                  <img src="../../../../../assets/icones/add.svg" alt="">
                                  <span>{{"Catalogs.overrides"|translate}}</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                  <div *ngIf="doesProductHaveRetailPrice(product)" class="product_has_no_pricing">
                    <img src="../../../../../assets/icones/alert-circle.svg" alt="">
                    <span>{{ product.variants?.length ? 'This product include variants without pricing details' : 'This product doesn\'t have pricing details'}}</span>
                  </div>
              </ng-container>
              </tbody>
            </table>
          </div>
        </div>
    </div>
    <div class="submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="cancel()">
        <span>{{submitType === 'stepper' ? ("common.back" | translate) : ("common.cancel" | translate)}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <button class="save_btn_pop_up blue_btn" *appHasPermission="submitPermission()" (click)="save()">
        <span>{{submitType === 'stepper' ? ("common.next" | translate | uppercase) : ("common.save" | translate | uppercase)}}</span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
</div>
